/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, HostListener } from '@angular/core';
import { WheelEvent } from 'react';

//TODO rename to iriroPreventScroll
@Directive({
  selector: '[irianPreventScrollDirective], [iriroPreventScrollDirective]',
})
export class PreventScrollDirective {
  @HostListener('wheel', ['$event'])
  handleWheelEvent(event: WheelEvent) {
    event.preventDefault();
  }
}
